export const GA_ID = 'G-S31BXFVM00';

declare global {
    interface Window {
        gtag: (...args: any[]) => void;
    }
}

export const pageview = (url: string) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('config', GA_ID, {page_path: url})
    }
}

export const sendGAEvent = (
    action: string,
    category: string,
    label: string,
    value?: number
) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('event', action, {
            event_category: category,
            event_label: label,
            value: value,
        });
    }
};

export const trackUserAction = (
    component: string,
    action: 'click' | 'view' | 'submit' | 'draw' | 'download' | 'view_modal' | "attempt_success" | "attempt_fail",
    context: string,
    value?: number
) => {
    sendGAEvent(
        `${action}_${component}`,
        `${context}_${component}`,
        `${component}_${context}`,
        value
    )
}

export const identifyUser = (userId: number | string, isStaff: boolean) => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('set', 'user_id', String(userId));
        window.gtag('set', 'user_properties', {
            user_type: isStaff ? 'staff' : 'external',
        });
    }
};

export const clearUserIdentity = () => {
    if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('set', 'user_id', null);
        window.gtag('set', 'user_properties', { user_type: null });
    }
};